import React from "react";
import { CircleActionButton } from "../CircleButton";
import { Pause, Play } from "lucide-react";
import { theme } from "@src/theme";
import Spinner from "../Spinner";

type PlayButtonProps = {
  onClick: () => void;
  isPlaying: boolean;
  styles?: React.CSSProperties;
  loading?: boolean;
};
const PlayButton: React.FC<PlayButtonProps> = ({
  isPlaying,
  onClick,
  styles,
  loading,
}) => {
  return (
    <CircleActionButton styles={styles} $active onClick={onClick}>
      {loading ? (
        <Spinner light small inline />
      ) : isPlaying ? (
        <Pause fill={theme.colors.darkBg} />
      ) : (
        <Play fill={theme.colors.darkBg} />
      )}
    </CircleActionButton>
  );
};

export default PlayButton;
